import { useState, useCallback } from 'react';
import { safeLocalStorage } from '@utils/common';
import { CSSRefTransition } from '@utils/react';
import { leaveTransitionDurationMs, wrapper, indicator } from './guide-bubble-with-animation.styles.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Overlay } from '../overlays/overlay/overlay.js';

function useGuideBubbleWithAnimationState(viewCountKey, targetCount = 1) {
  const [viewCount, setViewCount] = useState(parseInt(safeLocalStorage.getItem(viewCountKey) ?? "0", 10));
  return {
    enabled: viewCount < targetCount,
    onEnable: useCallback(() => {
      setViewCount(prevValue => {
        safeLocalStorage.setItem(viewCountKey, String(prevValue + 1));
        return prevValue + 1;
      });
    }, [viewCountKey])
  };
}
function GuideBubbleWithAnimation(props) {
  return /*#__PURE__*/jsx(CSSRefTransition, {
    timeout: leaveTransitionDurationMs,
    classNames: wrapper,
    in: props.active,
    mountOnEnter: true,
    unmountOnExit: true,
    children: ref => /*#__PURE__*/jsxs("div", {
      ref: ref,
      className: wrapper
      // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
      ,
      onMouseOver: props.onEnable,
      onMouseLeave: props.onDisable,
      children: [/*#__PURE__*/jsx("div", {
        className: indicator
      }), /*#__PURE__*/jsx(Overlay, {
        active: props.hovered,
        withArrow: false,
        placement: props.placement,
        offsetPx: 20,
        containerRef: ref,
        mountIn: document.body,
        children: /*#__PURE__*/jsx("iframe", {
          "aria-hidden": true,
          sandbox: "allow-scripts",
          src: props.animationUrl,
          width: props.animationWidth,
          height: props.animationHeight,
          frameBorder: 0,
          tabIndex: -1
        })
      })]
    })
  });
}

export { GuideBubbleWithAnimation, useGuideBubbleWithAnimationState };
//# sourceMappingURL=guide-bubble-with-animation.js.map
